module.exports = __webpack_public_path__ + "770d07ac82c146770de6c1055174a932.svg";